import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDirectorChair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDirectorChair"><Path d="M19.5 11.5H4.5V2.5H19.5V11.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 11.5H4.5L12 16.5L19.5 21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M21.5 11.5H19.5L12 16.5L4.5 21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDirectorChair;
